import { driverAPIToDriver, saveDriverParseToAPI } from './APITransformer';
import type { Driver, NewDriver } from './Types';

import type { UUID } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class DriversRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getDrivers = (): Promise<Driver[]> => {
    const requestData: IRequest = {
      endpoint: '/dash/driver',
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => response.data.drivers.map(driverAPIToDriver));
  };

  public saveDriver = (driver: Driver | NewDriver): Promise<Driver> => {
    const requestData: IRequest = {
      endpoint: '/dash/driver',
      method: HttpMethod.POST,
      body: JSON.stringify(saveDriverParseToAPI(driver)),
    };
    return this.requester.request(requestData).then((response) => driverAPIToDriver(response.data));
  };

  public deleteDriver = (driverId: UUID): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/dash/driver',
      method: HttpMethod.DELETE,
      body: JSON.stringify({ id: driverId }),
    };
    return this.requester.request(requestData).then();
  };
}

export default DriversRequester;
